/**
 * Photo scene cue (setting + season) types, prompt clause and parser. Dependency-free on purpose: the comic
 * client bundle (MangaPhotoStep) imports this, so it must never import templates or server code.
 */
export type SceneSetting = 'beach' | 'snow' | 'park' | 'forest' | 'city' | 'home' | 'garden' | 'mountains' | 'festival' | 'other';
export type SceneSeason = 'spring' | 'summer' | 'autumn' | 'winter' | 'unknown';
export interface PhotoScene { setting: SceneSetting; season: SceneSeason }

export const SCENE_SETTINGS: readonly SceneSetting[] = ['beach', 'snow', 'park', 'forest', 'city', 'home', 'garden', 'mountains', 'festival', 'other'];
export const SCENE_SEASONS: readonly SceneSeason[] = ['spring', 'summer', 'autumn', 'winter', 'unknown'];

/** Appended to the photo-analysis prompt when the flow asks for scene cues. */
export const SCENE_PROMPT_CLAUSE = `

Also describe where the photo was taken. Add a top-level key "scene" next to the person keys: {"scene": {"setting": <one of ${SCENE_SETTINGS.map((s) => `"${s}"`).join(', ')}>, "season": <one of ${SCENE_SEASONS.map((s) => `"${s}"`).join(', ')}>}}. Use "other" or "unknown" when unsure.`;

/** A scene answer with both values inside the enums, else null. */
export function parsePhotoScene(raw: unknown): PhotoScene | null {
  const r = raw as { setting?: unknown; season?: unknown } | null | undefined;
  if (!r || typeof r !== 'object') return null;
  const setting = typeof r.setting === 'string' ? r.setting.trim().toLowerCase() : '';
  const season = typeof r.season === 'string' ? r.season.trim().toLowerCase() : '';
  if (!(SCENE_SETTINGS as readonly string[]).includes(setting) || !(SCENE_SEASONS as readonly string[]).includes(season)) return null;
  return { setting: setting as SceneSetting, season: season as SceneSeason };
}
